import { QBankStructureValidationCase } from '@exam-management/graphql';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Alert, AlertTitle, Flex, List, Text } from '@shared/components';

export default function QBankStructureValidationErrorsAlert() {
  const { validatePublishQBankStructure } = useQBankStructure();

  const { errors } = validatePublishQBankStructure;

  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <Alert
      severity='error'
      sx={{
        alignItems: 'flex-start',
        '& .MuiAlert-message': {
          overflow: 'unset',
        },
        marginX: (theme) => theme.spacing(6),
        marginTop: (theme) => theme.spacing(6),
      }}
    >
      <AlertTitle
        variant='body1Semibold'
        sx={(theme) => ({
          m: theme.spacing(0),
          //TODO: Remove font weight override when fix AlertTitle font weight override issue
          fontWeight: 600,
        })}
      >
        ไม่สามารถ Publish โครงสร้างคลังข้อสอบได้
      </AlertTitle>
      <Flex
        sx={{
          flexDirection: 'column',
        }}
      >
        <Text variant='body2'>กรุณาตรวจสอบและแก้ไขรายการต่อไปนี้ก่อนเผยแพร่:</Text>
        <List sx={{ listStyle: 'disc' }}>
          {errors.some(
            (error) => error.type === QBankStructureValidationCase.MissingNameInInformationItem,
          ) ? (
            <Text variant='body2' component='li' sx={{ ml: 6 }}>
              กรุณาระบุชื่อโครงสร้างคลังข้อสอบ
            </Text>
          ) : null}
          {errors.some(
            (error) => error.type === QBankStructureValidationCase.MissingLastLevelItem,
          ) ? (
            <Text variant='body2' component='li' sx={{ ml: 6 }}>
              กรุณากำหนดหัวข้อย่อย (Subtopic) ในโครงสร้างคลังข้อสอบให้ครบถ้วน
            </Text>
          ) : null}
        </List>
      </Flex>
    </Alert>
  );
}
